import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

//TODO: use in add-linked-subscriber-form
export function emailMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;
    const emailControl = control.parent.get('email');
    if (!emailControl) {
      return null;
    }

    // Let `required` handle empties; this validator only cares about mismatches.
    const email = String(emailControl.value ?? '')
      .trim()
      .toLowerCase();
    const confirmation = String(control.value ?? '')
      .trim()
      .toLowerCase();

    if (!email || !confirmation) return null;

    return email === confirmation ? null : { emailMismatch: true };
  };
}
